import { find } from "./lib/dom.js"

const studentSelect = find("#meeting_student_id")
if (studentSelect) {
  studentSelect.classList.add("form-control")
  studentSelect.setAttribute("aria-label", "請連結學生")
}
